import { apiProxyRequest } from "Api/apiProxyRequest";

import type { BillingAlert } from "Reducers/organization/billingAlert";

export const getBillingAlertRequest = (organizationId: string) =>
  apiProxyRequest<BillingAlert>(
    `/organizations/${organizationId}/alerts/billing`
  );
